module.exports = __webpack_public_path__ + "img/block.07bbdd45.svg";